import { Box } from '@mui/material'

import LabeledTextField from '@/components/dataDisplay/LabeledTextField'

export type KeyValueItem = Readonly<{
  label: string
  value?: string | null
}>

type KeyValueGridProps = Readonly<{
  items: ReadonlyArray<KeyValueItem>
  /** Number of columns at the `md` breakpoint and above. Defaults to 2. */
  columns?: 1 | 2 | 3
}>

const columnTemplates = {
  1: { xs: '1fr' },
  2: { xs: '1fr', sm: 'repeat(2, 1fr)' },
  3: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
} as const

export function KeyValueGrid({ items, columns = 2 }: KeyValueGridProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: columnTemplates[columns],
        columnGap: 4,
        rowGap: 2,
      }}
    >
      {items.map((item) => (
        <LabeledTextField key={item.label} label={item.label} text={item.value} />
      ))}
    </Box>
  )
}
